// libs
import { styled } from '@nykaa/ui-components';

// components
import { Dots as BaseDots } from 'shared/components/Carousel';

export const CarouselContainer = styled.div<{ marginTop?: number }>`
  width: 100%;
  margin-bottom: 20px;

  ${({ marginTop }) => marginTop && ` margin-top: ${marginTop}px`}
`;

export const Placeholder = styled.div<{ bgColor: string; aspectRatio: number; marginTop?: number }>`
  width: 100%;

  ${({ bgColor, aspectRatio }) => `
        padding-top: ${100 / aspectRatio}%;
        margin-bottom: 40px;
        background: ${bgColor};
    `}

  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}px`}
`;

export const Dots = styled(BaseDots)`
  position: relative;
`;
